import React from "react";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ToastProvider } from "./commoncomponents/ToastProvider";
import "./index.css"

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode> 
    <ToastProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ToastProvider>
  // </React.StrictMode>
);
